import React from 'react';

const UbsChat = ({style = {}, size = "36", className = "", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d="M19.344 3C11.25 3 4.693 9.55 4.693 17.634c0 2.859.817 5.523 2.24 7.776L2 33.222l10.601-2.597a14.602 14.602 0 006.743 1.637c3.669 0 7.03-1.35 9.6-3.577l-3.439-.898a11.863 11.863 0 01-6.161 1.719c-2.112 0-4.096-.55-5.812-1.514l-5.838 1.16 2.282-4.209a11.82 11.82 0 01-2.518-7.31c0-6.56 5.324-11.877 11.891-11.877 6.568 0 11.891 5.318 11.891 11.878a11.815 11.815 0 01-1.51 5.795l1.598 2.633A14.529 14.529 0 0034 17.634C33.99 9.55 27.432 3 19.344 3z"
            fill="#60B158"
        />
        <path
            d="M30.973 27.977l-3.515-5.652a9.334 9.334 0 001.254-4.681c0-5.179-4.204-9.378-9.389-9.378s-9.389 4.199-9.389 9.378c0 5.18 4.204 9.378 9.39 9.378a9.383 9.383 0 004.013-.898l7.636 1.853z"
            fill="#007AFF"
        />
        <path
            d="M15.752 19.03a1.382 1.382 0 100-2.764 1.382 1.382 0 000 2.764zm3.782 0a1.382 1.382 0 10.001-2.764 1.382 1.382 0 000 2.764zm3.644 0a1.382 1.382 0 10.001-2.764 1.382 1.382 0 00-.001 2.764z"
            fill="#FFA700"
        />
    </svg>
);

export default UbsChat;